/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import { TrainClass }         from './train.class';

/**
 *
 * @class TSOSpeed
 *
 * @brief companion for TSO object; each slow order spans some number of train class/speed pairs to
 * indicate which kinds of trains travel at which kinds of speeds under this slow order.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class TSOSpeed {

  /** the id for the parent TSO (tso_id) */
  public             _tsoId: number          = -1;

  /** the id for the contained train class (train_class_id) */
  public              _tcId: number          = 0;

  /** the the speed for this train class */
  public             _speed: number          = 0;

  /** the actual track in scope */
  public        _trainClass: TrainClass|null = null;

  /** @var the zero based index for this item */
  public               _nth: number          = -1;

  /** @brief standard constructor */
  constructor(      tsoId: number,
                     tcId: number,
                    speed: number,
               trainClass: TrainClass|null,
                      nth: number) {

    this._tsoId      = tsoId;
    this._tcId       = tcId;
    this._speed      = speed;
    this._trainClass = trainClass;
    this._nth        = nth;
  }

  /** create a new separate clone */
  public dup(): TSOSpeed {

    return new TSOSpeed(
      this._tsoId,
      this._tcId,
      this._speed,
      this._trainClass,
      this._nth
    );
  }

}
